import React from 'react';
import { Box, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';

interface DeletedPlaceholderProps {
  variant?: 'thumbnail' | 'detail';
}

export const DeletedPlaceholder: React.FC<DeletedPlaceholderProps> = ({
  variant = 'thumbnail',
}) => {
  const isDetail = variant === 'detail';

  return (
    <Box
      data-testid="deleted-placeholder"
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1,
        gap: isDetail ? 1.5 : 0.5,
      }}
    >
      <Delete
        sx={{
          fontSize: isDetail ? 48 : 24,
          color: 'grey.500',
        }}
      />
      {isDetail && (
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >
          Deleted
        </Typography>
      )}
    </Box>
  );
};
